<div id="top-of-page"></div>
<app-back-header
  [headerText]="'Torna alla lista Clienti'"
  (backAction)="onCancel()"
  class="sticky-top"
>
</app-back-header>

<!-- I blocchi entrano uno dopo l'altro dall'alto (.izy-enter + ritardo per
     posizione, come in dashboard e nel dettaglio fattura). -->
<div
  class="d-flex flex-column flex-md-row gap-3 justify-content-between align-items-start mt-3 ms-1 mb-3 w-100 izy-enter"
  style="animation-delay: 0ms">
  <div>
    <h3 class="m-0">Modifica cliente</h3>
    <p class="m-0 text-muted">Clicca su una scheda per espanderne il contenuto</p>
  </div>
  <!-- Stesso bottom sheet di "Vedi fatture" nel menu della lista clienti. -->
  <button
    mat-stroked-button
    type="button"
    class="izy-button-ghost custom-button-border flex-shrink-0 izy-header-action"
    [disabled]="isLoading"
    (click)="openCompanyInvoicesBottomSheet()"
  >
    <mat-icon>payments</mat-icon>
    Vedi fatture
  </button>
</div>

<p class="ms-1 small text-muted izy-enter" style="animation-delay: 60ms">
  I campi contrassegnati da * sono obbligatori.
</p>

<form [formGroup]="companyForm" (ngSubmit)="onSubmit()">
  <mat-expansion-panel
    class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 120ms"
    [expanded]="true"
    #panel
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        Cliente
      </mat-panel-title>
      <mat-panel-description>
        {{ companyForm.get('company_name')?.value ? companyForm.get('company_name')?.value : 'Cliente' }}
        <span class="panel-state">{{ panel.expanded ? 'Chiudi' : 'Apri' }}</span>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="row">
      <mat-form-field appearance="outline" class="w-sm-50">
        <mat-label>Nome cliente</mat-label>
        <input matInput formControlName="company_name" required />
      <mat-error *ngIf="companyForm.get('company_name')?.invalid">
        <span *ngIf="companyForm.get('company_name')?.errors?.['required']">
          Il nome è obbligatorio
        </span>
        <span *ngIf="companyForm.get('company_name')?.errors?.['pattern']">
          Solo lettere (a-z, A-Z), numeri, spazi e punti sono ammessi
        </span>
      </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-50">
        <mat-label>Tipo</mat-label>
        <mat-select
          formControlName="type"
          class="izy-select-trigger"
          panelClass="izy-select-panel izy-select-panel--form"
        >
          <mat-option *ngFor="let type of typeOptions" [value]="type.code">
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Partita IVA</mat-label>
        <input
          matInput
          formControlName="iva_number"
          maxlength="11" />
        <mat-error *ngIf="companyForm.get('iva_number')?.invalid">
          <span *ngIf="companyForm.get('iva_number')?.errors?.['pattern']">
            La Partita Iva deve essere composta esattamente da 11 cifre
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Codice fiscale</mat-label>
        <input
          matInput
          formControlName="c_f"
          maxlength="16" />
        <mat-error *ngIf="companyForm.get('c_f')?.invalid">
          <span *ngIf="companyForm.get('c_f')?.errors?.['pattern']">
            Il Codice Fiscale deve essere composto esattamente da 11 o 16 caratteri alfanumerici
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Codice SDI</mat-label>
        <input
          matInput
          formControlName="addressee_code"
          minlength="6"
          maxlength="7"
          required
          />
          <mat-error *ngIf="companyForm.get('addressee_code')?.invalid">
            <span *ngIf="companyForm.get('addressee_code')?.errors?.['pattern']">
              Il Codice SDI deve essere composto esattamente da 6 o 7 caratteri alfanumerici maiuscoli
            </span>
          </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Codice interno (opzionale)</mat-label>
        <input matInput formControlName="internal_code" />
      </mat-form-field>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel
    class="mt-3 mb-3 mb-md-2 col-md-12 d-flex flex-column custom-card izy-sharp-bl izy-enter"
    style="animation-delay: 180ms"
    [expanded]="true"
    #panel2
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        Dati anagrafici
      </mat-panel-title>
      <mat-panel-description>
        {{ companyForm.get('city')?.value ? companyForm.get('city')?.value : 'Indirizzo' }}{{ companyForm.get('province')?.value ? ' (' + companyForm.get('province')?.value + ')' : '' }}
        <span class="panel-state">{{ panel2.expanded ? 'Chiudi' : 'Apri' }}</span>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="row">
      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Indirizzo</mat-label>
        <input matInput formControlName="address" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Città</mat-label>
        <input matInput formControlName="city" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Comune</mat-label>
        <input matInput formControlName="comune" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>CAP</mat-label>
        <input
          matInput
          formControlName="cap"
          maxlength="5" />
        <mat-error *ngIf="companyForm.get('cap')?.invalid">
          <span *ngIf="companyForm.get('cap')?.errors?.['pattern']">
            Il CAP deve essere composto da 5 cifre
          </span>
        </mat-error>
      </mat-form-field>

    </div>

    <div class="row">

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Provincia (sigla)</mat-label>
        <input
          matInput
          formControlName="province"
          name="province"
          required
          minlength="2"
          maxlength="2"
          (blur)="validateProvince(companyForm.get('province')?.value)"
          />
        <mat-error *ngIf="companyForm.get('province')?.invalid">
          <span *ngIf="companyForm.get('province')?.errors?.['pattern']">
            La provincia deve essere di esattamente 2 lettere maiuscole
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Nazione</mat-label>
        <mat-select
          formControlName="country"
          class="izy-select-trigger"
          panelClass="izy-select-panel izy-select-panel--form"
        >
          <mat-option *ngFor="let country of countryOptions" [value]="country.code">
            {{ country.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Telefono</mat-label>
        <input matInput formControlName="telephone" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Cellulare</mat-label>
        <input matInput formControlName="cellphone" />
      </mat-form-field>
    </div>

    <div class="row">

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email_address" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-sm-25">
        <mat-label>Pec</mat-label>
        <input matInput formControlName="pec" />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline" class="w-sm-50">
        <mat-label>Note (opzionali)</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="6"
          formControlName="notes"
        ></textarea>
      </mat-form-field>
    </div>

    <!-- L'unica azione della schermata: petrol pieno bordato nero. Il click e'
         gestito dal (ngSubmit) del form, quindi il pulsante e' solo type submit
         (con anche un (click)="onSubmit()" il salvataggio partirebbe due volte).
         .hidden-mobile non impone un display, quindi l'allineamento a destra
         passa da text-end: il pulsante e' inline-flex. -->
    <div class="text-end hidden-mobile">
      <button
        matButton="filled"
        type="submit"
        [disabled]="!companyForm.valid"
        class="mt-2 izy-button-primary custom-button-border"
      >
        <mat-icon>save</mat-icon>
        Salva modifiche
      </button>
    </div>
    <!-- mobile version -->
    <div class="visible-mobile">
      <button
        matButton="filled"
        type="submit"
        [disabled]="!companyForm.valid"
        class="w-100 mt-2 izy-button-primary custom-button-border"
      >
        <mat-icon>save</mat-icon>
        Salva modifiche
      </button>
    </div>
  </mat-expansion-panel>
</form>

<div class="pt-3 mb-3"></div>

<div *ngIf="isLoading" class="loading-overlay">
  <mat-spinner diameter="40"></mat-spinner>
  <p>Caricamento in corso...</p>
</div>
